import { gridParameterizationType } from "../../utils";
import LoadCapacityFilter from "./components/load-capacity-filter";
import UnloadCapacityFilter from "./components/unload-capacity-filter";

interface IGridParameterizationFilterProps {
  type: string;
}

const GridParameterizationFilter = ({ type }: IGridParameterizationFilterProps) => {
  return (
    <div style={{ width: "35%", display: "flex", flexDirection: "column", height: "100%" }}>
      {type === gridParameterizationType.UnloadCapacity ? (
        <UnloadCapacityFilter />
      ) : (
        <LoadCapacityFilter />
      )}
    </div>
  );
};

export default GridParameterizationFilter;
